import { StyleParamType, wixColorParam, wixFontParam } from '@wix/tpa-settings';

const expandInstagramStyleParams = {
  /// //////////////////////
  // BOOLEANS
  /// //////////////////////
  e_isDisplayProfileInfo: {
    type: StyleParamType.Boolean,
    key: 'e_isDisplayProfileInfo',
    getDefaultValue: () => true,
  },
  e_isDisplayCaption: {
    type: StyleParamType.Boolean,
    key: 'e_isDisplayCaption',
    getDefaultValue: () => true,
  },
  e_isDisplayCounters: {
    type: StyleParamType.Boolean,
    key: 'e_isDisplayCounters',
    getDefaultValue: () => true,
  },
  e_isDisplayComments: {
    type: StyleParamType.Boolean,
    key: 'e_isDisplayComments',
    getDefaultValue: () => true,
  },
  e_isDisplayTimestamp: {
    type: StyleParamType.Boolean,
    key: 'e_isDisplayTimestamp',
    getDefaultValue: () => true,
  },
  e_isStoryAutoplaySoundOn: {
    type: StyleParamType.Boolean,
    key: 'e_isStoryAutoplaySoundOn',
    getDefaultValue: () => true,
  },
  /// //////////////////////
  // NUMBERS
  /// //////////////////////
  /// //////////////////////
  // COLORS
  /// //////////////////////
  e_bgColor: {
    type: StyleParamType.Color,
    key: 'e_bgColor',
    getDefaultValue: wixColorParam('color-5', 0.6),
  },
  e_iconsColor: {
    type: StyleParamType.Color,
    key: 'e_iconsColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  e_mobileIconsColor: {
    type: StyleParamType.Color,
    key: 'e_mobileIconsColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  e_primaryColor: {
    type: StyleParamType.Color,
    key: 'e_primaryColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  e_seconderyColor: {
    type: StyleParamType.Color,
    key: 'e_seconderyColor',
    getDefaultValue: wixColorParam('color-4'),
  },
  e_panelColor: {
    type: StyleParamType.Color,
    key: 'e_panelColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  e_dividers: {
    type: StyleParamType.Color,
    key: 'e_dividers',
    getDefaultValue: wixColorParam('color-5', 0.2),
  },
  e_linksColor: {
    type: StyleParamType.Color,
    key: 'e_linksColor',
    getDefaultValue: wixColorParam('color-8'),
  },
  e_storyOverlayColor: {
    type: StyleParamType.Color,
    key: 'e_storyOverlayColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  e_storyTextColor: {
    type: StyleParamType.Color,
    key: 'e_storyTextColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  e_storyIconsColor: {
    type: StyleParamType.Color,
    key: 'e_storyIconsColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  /// //////////////////////
  // FONTS
  /// //////////////////////
  storyFont: {
    type: StyleParamType.Font,
    key: 'storyFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 24,
    }),
  },
  instaExpandFont: {
    type: StyleParamType.Font,
    key: 'instaExpandFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
};

export default expandInstagramStyleParams;
